import React from 'react';
import Waypoint from 'react-waypoint';

import BaseSectionBookend from './BaseSectionBookend';
import Navigation from '../Navigation';
import KittenInTab from './KittenInTab';
import InstallButton from '../InstallButton';

class LastSection extends BaseSectionBookend {
	render() {
		return (
			<div className="section section--centered section--full-height section--last bg--purple">
				<Navigation />

				<div className={this.getClassNames()}>
					<h2>Get Tabbies in your Tabs.</h2>
					<p>Available for Google Chrome and Firefox.</p>
					<InstallButton classNames={'install-button install-button--purple'} hoverOnButton={this.hoverOnButton} hoverOffButton={this.hoverOffButton} />
					<Waypoint onEnter={this.wayPointEntered} />
				</div>

				<div className="hero--illustration">
					<div className="hero--cats">
						<KittenInTab beingPet={this.state.buttonHover} color="orange" />
					</div>
				</div>
			</div>
		);
	}
}

export default LastSection;



// WEBPACK FOOTER //
// ./src/components/Site/Home/SectionLast.js